import React from 'react';
import { getPinColor, PinTypes } from './pins';

const entries: { label: string; type: PinTypes }[] = [
    { label: 'Primary', type: 'primary' },
    { label: 'External', type: 'source' },
    { label: 'Nearby', type: 'nearby-facility' }
];

export const MarkerLegend = () => (
    <div className="absolute top-5 right-5 z-10 min-w-40 rounded-md border bg-background p-2 shadow-md">
        <ul className="flex flex-col gap-1">
            {entries.map(({ label, type }) => (
                <li
                    key={type}
                    className="flex items-center justify-between gap-3 text-sm"
                >
                    <span>{label}</span>
                    <span
                        className="size-5 rounded"
                        style={{ backgroundColor: getPinColor(type) }}
                    />
                </li>
            ))}
        </ul>
    </div>
);
